import { useState } from "react";
import { createContainer } from "unstated-next";
import { ChargeType, initVerifyRechargeInfo } from "../constants";
import { ThemeType } from "project-config/client-theme/client-theme";
import { VerifyRechargeInfo } from "@/components/top-up/types";

function useClientTopUpStoreHook() {
  const [activeBar, setActiveBar] = useState<ChargeType>(ChargeType.Membership);

  const [isCheckCard, setIsCheckCard] = useState(true);
  const [rechargeAmount, setRechargeAmount] = useState(0);
  const [hasScanned, setHasScanned] = useState(false);
  const [rechargeSecondActiveName, setRechargeSecondActiveName] = useState(""); // 充值tab的二级tab
  const [themeName, setThemeName] = useState(ThemeType.Light);
  const [showCouponCodeModal, setShowCouponCodeModal] = useState(false);
  const [inputCode, setInputCode] = useState("");
  const [verifyRechargeInfo, setVerifyRechargeInfo] =
    useState<VerifyRechargeInfo>(initVerifyRechargeInfo);
  return {
    activeBar,
    setActiveBar,
    rechargeAmount,
    setRechargeAmount,
    hasScanned,
    setHasScanned,
    rechargeSecondActiveName,
    setRechargeSecondActiveName,
    isCheckCard,
    setIsCheckCard,
    themeName,
    setThemeName,
    showCouponCodeModal,
    setShowCouponCodeModal,
    inputCode,
    setInputCode,
    verifyRechargeInfo,
    setVerifyRechargeInfo,
  };
}

const ClientTopUpStoreContainer = createContainer(useClientTopUpStoreHook);
export const ClientTopUpStoreProvider = ClientTopUpStoreContainer.Provider;

export function useClientTopUpStore() {
  return ClientTopUpStoreContainer.useContainer();
}
